export {
	documentsPageBodyInset,
	documentsPageInset,
	documentsPageToolbar,
	documentsTableCard,
} from "@/src/routes/dashboard/_shell/document/all/-lib/documents-page-layout";

export const adminPageRoot =
	"flex min-h-0 flex-1 flex-col bg-background @container";
